import { render, staticRenderFns } from "./WebsiteNewsList.vue?vue&type=template&id=17342080&scoped=true&"
import script from "./WebsiteNewsList.vue?vue&type=script&lang=js&"
export * from "./WebsiteNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17342080",
  null
  
)

export default component.exports